<template>
	<article class="banner-manage-page">
		<form @submit.prevent="searching">
			<table class="detail" style="margin-top: 15px">
				<tr>
					<th>메인배너명</th>
					<td colspan="3">
						<input v-model="params.bannerTitle" type="text" />
					</td>

					<th>분류</th>
					<td>
						<RadioList
							v-model="params.type"
							:radio-list="typeList"
						/>
					</td>

					<th>노출기간</th>
					<td>
						<input-date v-model="params.startDate" class="short" />
						<span style="margin: 0 5px">~</span>
						<input-date v-model="params.endDate" class="short" />
					</td>
				</tr>
			</table>

			<section style="text-align: center; margin-top: 15px">
				<button class="btn-main blue" type="submit">검색</button>
			</section>
		</form>

		<managing-section :is-table="true">
			<template slot="infoSection">
				<div class="section__info__left">
					<p>
						등록 : {{ totalCnt }}건 / 활성 : {{ isDisplayCnt }}건 /
						비활성 : {{ unIsDisplayCnt }}건
						<span class="banner-manage-page__desc"
							>※ 활성 배너가 21개 이상일 경우 랜덤으로 20개만
							노출됩니다.</span
						>
					</p>
				</div>
				<div class="section__info__right">
					<select
						class="select section__info__items"
						v-model="sort"
						@change="searching"
					>
						<option
							v-for="item in sortList"
							:key="item.id"
							:value="item.id"
						>
							{{ item.value }}
						</option>
					</select>
					<select
						class="select section__info__items"
						v-model="limit"
						@change="searching"
					>
						<option
							v-for="item in getLimitList()"
							:key="item.id"
							:value="item.id"
						>
							{{ item.name }}
						</option>
					</select>
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th v-for="th in thList" :key="th">{{ th }}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, idx) in list" :key="item.idBanner">
						<td>
							<input-text
								@input="item.sortKey = $event"
								mode="number"
								:use-minus="true"
								:prop-value="item.sortKey"
							/>
						</td>
						<td>
							<input type="text" v-model="item.bannerTitle" />
						</td>
						<td>
							<img-selector
								@change="imgObjList[idx] = $event"
								:use-cancel="true"
								:src="item.src"
								cancel-btn-text="삭제"
							/>
						</td>
						<td class="white-space__nowrap text-left">
							<ManagingSection class="banner-manage-page__info">
								<ManagingBox title="타이틀">
									<TextCounter
										v-model="item.displayTitle"
										:useTextarea="true"
										:rows="2"
										:useLineLimit="true"
										:maxLength="10"
										:lengthExceptSpacing="true"
									/>
								</ManagingBox>
								<ManagingBox title="디스크립션">
									<TextCounter
										v-model="item.description"
										:useTextarea="true"
										:rows="2"
										:useLineLimit="true"
										:maxLength="100"
										:lengthExceptSpacing="true"
									/>
								</ManagingBox>
								<ManagingBox title="광고여부">
									<RadioList
										v-model="item.isAd"
										:radioList="isAdList"
									/>
								</ManagingBox>
								<ManagingBox title="링크종류">
									<select
										class="select banner-manage__link-period-input"
										v-model="item.linkType"
									>
										<option
											v-for="item in linkTypeList"
											:key="item.id"
											:value="item.id"
										>
											{{ item.name }}
										</option>
									</select>
								</ManagingBox>
								<ManagingBox title="링크값">
									<input
										class="banner-manage__link-period-input"
										type="text"
										v-model="item.linkValue"
									/>
								</ManagingBox>
								<ManagingBox title="기간">
									<form
										:id="`${item.idBanner}${idx}`"
										@submit.prevent="saveBanner(item, idx)"
									>
										<DateRange
											:value="dateList[idx]"
											class="banner-manage__link-period-input"
											@input="dateChange($event, idx)"
										/>
									</form>
								</ManagingBox>
							</ManagingSection>
						</td>
						<td>
							<button
								:form="`${item.idBanner}${idx}`"
								type="submit"
								class="btn blue banner-manage__option-btn"
								v-text="'저장'"
							/>
							<button
								class="btn red banner-manage__option-btn"
								type="button"
								v-text="'삭제'"
								@click="deleteBanner(item.idBanner)"
							/>
						</td>
					</tr>
				</tbody>
			</table>
			<pagination-box
				slot="pagination"
				@to="paging($event.offset)"
				:total-item="totalCnt"
				:offset="offset"
				:limit="limit"
			/>
		</managing-section>
	</article>
</template>
<script>
	import _ from 'lodash';
	import moment from 'moment';
	import isEqual from 'lodash/isEqual';
	import { isLinkValueRequired, getS3Url, uploadS3 } from '@/util.js';
	import { mapState, mapGetters } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import RadioList from '@/components/RadioList';
	import InputDate from '@/components/InputDate.vue';
	import InputText from '@/components/InputText.vue';
	import ImgSelector from '@/components/ImgSelector.vue';
	import DateRange from '@/components/DateRange';
	import PaginationBox from '@/components/PaginationBox.vue';
	import TextCounter from '@/components/TextCounter.vue';

	export default {
		name: 'MainBannerManage',
		components: {
			ManagingSection,
			ManagingBox,
			RadioList,
			InputDate,
			InputText,
			ImgSelector,
			DateRange,
			PaginationBox,
			TextCounter,
		},
		data() {
			const isAdList = [
				{ id: false, value: 'N' },
				{ id: true, value: 'Y' },
			];

			return {
				params: {
					bannerTitle: null,
					startDate: null, // - string (14자리) db 따름
					endDate: null, // - string (14자리) db 따름
					type: null,
				},
				typeList: [
					{ id: null, value: '전체보기' },
					{ id: 'doing', value: '진행중' },
					{ id: 'before', value: '미진행중' },
				],
				sortList: [
					{ id: 1, value: '정렬순' },
					{ id: 2, value: '정렬역순' },
					{ id: 3, value: '최신순' },
					{ id: 4, value: '이전등록순' },
				],
				sort: 1,
				limit: 10,
				offset: 0,
				thList: [
					'순서',
					'메인배너명',
					'이미지',
					'메인배너정보',
					'옵션',
				],
				dateList: null,
				imgObjList: null,
				list: null,
				isDisplayCnt: 0,
				totalCnt: 0,
				unIsDisplayCnt: 0,
				isAdList,
			};
		},
		computed: {
			...mapState({
				IMAGE_STORAGE_PATH: state => state.env.IMAGE_STORAGE_PATH,
			}),
			...mapGetters(['getLimitList', 'getListAddNull']),
			linkTypeList() {
				return this.getListAddNull('newLinkType');
			},
		},
		created() {
			this.setFilter();
			this.getList();
		},
		methods: {
			setFilter() {
				const query = this.$route.query;
				if (query.sort) {
					this.sort = Number(query.sort);
				}
				if (query.limit) {
					this.limit = Number(query.limit);
				}
				if (query.offset) {
					this.offset = Number(query.offset);
				}
				if (query.type) {
					this.params.type = query.type;
				}
			},
			async deleteBanner(id) {
				try {
					await this.$axiosAdmin2.delete(`/api/banner/${id}`);
					window.location.reload();
				} catch (err) {
					console.error(err);
					alert(
						'메인배너를 삭제하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			validate(obj, idx) {
				if (isNaN(parseInt(obj.sortKey))) {
					alert('정렬순서를 입력하세요.');
					return false;
				}
				if (!obj.bannerTitle) {
					alert('배너명을 입력하세요.');
					return false;
				}
				if (this.imgObjList[idx] === null) {
					alert('사진을 추가하세요.');
					return false;
				}
				if (!obj.linkType) {
					alert('링크종류을 선택하세요.');
					return false;
				}
				if (!obj.linkValue && isLinkValueRequired(obj.linkType)) {
					alert('링크값을 입력하세요.');
					return false;
				}
				if (!this.dateList[idx].from) {
					alert('시작일을 입력하세요.');
					return false;
				}
				if (!this.dateList[idx].to) {
					alert('종료일를 입력하세요.');
					return false;
				}

				if (
					moment(this.dateList[idx].from).valueOf() >
					moment(this.dateList[idx].to).valueOf()
				) {
					alert('종료일시는 시작일시보다 빠를수 없습니다.');
					return false;
				}

				return true;
			},
			async getImgUrl(obj) {
				try {
					const { data } = await getS3Url(
						obj.extension,
						'main_banner'
					);
					await uploadS3(data, obj.fileObj);
					return `${this.IMAGE_STORAGE_PATH}/${data.fields.key}`;
				} catch (err) {
					console.error(err);
					alert(
						'이미지를 등록하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			async saveBanner(obj, idx) {
				try {
					this.$store.commit('toggleSpinner', true);
					if (!this.validate(obj, idx)) return;
					const params = {
						idBanner: obj.idBanner,
						sortKey: obj.sortKey,
						bannerType: 'MAIN',
						bannerTitle: obj.bannerTitle,
						linkType: obj.linkType,
						linkValue: obj.linkValue,
						startDate: moment(
							this.dateList[idx].from,
							'YYYY-MM-DDTHH:mm'
						).format('YYYYMMDDHHmmss'),
						endDate: moment(
							this.dateList[idx].to,
							'YYYY-MM-DDTHH:mm'
						).format('YYYYMMDDHHmmss'),
						displayTitle: obj.displayTitle,
						description: obj.description,
						isAd: obj.isAd,
					};
					const imgObj = this.imgObjList[idx];
					if (imgObj) {
						params.saveImageUrl = await this.getImgUrl(imgObj);
					} else if (imgObj === null) {
						params.saveImageUrl = null;
					} else if (imgObj === undefined) {
						params.saveImageUrl = `${this.IMAGE_STORAGE_PATH}${obj.fileDir}/${obj.fileSaveName}`;
					}
					await this.$axiosAdmin2.post('/api/banner', params);
					window.location.reload();
				} catch (err) {
					console.error(err);
					alert(
						'메인배너를 저장하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				} finally {
					this.$store.commit('toggleSpinner', false);
				}
			},
			dateChange(date, idx) {
				const list = [...this.dateList];
				list[idx] = date;
				this.dateList = list;
			},
			setQuery() {
				const query = {
					sort: String(this.sort),
					limit: String(this.limit),
					offset: String(this.offset),
				};
				if (this.params.type) {
					query.type = this.params.type;
				}
				if (isEqual(query, this.$route.query)) return;
				this.$router.replace({ query });
			},
			async getList() {
				try {
					const params = {
						sort: this.sort,
						limit: this.limit,
						offset: this.offset,
						..._.pickBy(this.params, _.identify),
					};
					if (params.startDate) {
						params.startDate =
							params.startDate.split('-').join('') + '000000';
					}
					if (params.endDate) {
						params.endDate =
							params.endDate.split('-').join('') + '235959';
					}

					const { data } = await this.$axiosAdmin2.get(
						`/api/banners`,
						{ params }
					);
					this.dateList = [];
					this.imgObjList = [];
					const list = data.banners.data.map(item => {
						if (item.fileSaveName) {
							item.src = `${this.IMAGE_STORAGE_PATH}${item.fileDir}/${item.fileSaveName}`;
						}
						this.dateList.push({
							from: item.startDate
								? moment(
										item.startDate,
										'YYYYMMDDHHmmss'
									).format('YYYY-MM-DDTHH:mm')
								: '',
							to: item.endDate
								? moment(item.endDate, 'YYYYMMDDHHmmss').format(
										'YYYY-MM-DDTHH:mm'
									)
								: '',
						});
						this.imgObjList.push(undefined);
						return item;
					});
					this.list = list;
					this.isDisplayCnt = data.bannerCountInfo.isDisplayCnt;
					this.totalCnt = data.bannerCountInfo.totalCnt;
					this.unIsDisplayCnt = data.bannerCountInfo.unIsDisplayCnt;
				} catch (err) {
					console.error(err);
					alert(
						'목록을 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				} finally {
					this.setQuery();
				}
			},
			searching() {
				this.offset = 0;
				this.getList();
			},
			paging(offset) {
				this.offset = offset;
				this.getList();
			},
		},
	};
</script>
<style lang="scss">
	.banner-manage-page {
		&__desc {
			display: block;
			color: $btn-blue;
			font-weight: 700;
		}

		&__info {
			padding-top: 0 !important;
		}
	}

	.banner-manage-page .banner-manage__link-period-input {
		display: block;
		margin-left: 8px;
		width: 524px;
	}

	.banner-manage-page .banner-manage__option-btn {
		display: block;
		margin-top: 8px;

		&:first-child {
			margin-top: 0;
		}
	}

	TABLE.detail {
		TH {
			width: 10%;
			text-align: center;
		}
	}
</style>
